import { Module } from 'vuex';
import { IRootState, IAdminClientState } from '@types';

import { AClientModel } from '@model';

import Env from '@lib/Env';

import { AClientApi } from '@/api';

const store: Module<IAdminClientState, IRootState> = {
    state: {
        client: <AClientModel>null,
        clients: <AClientModel[]>[],
        projects: <any[]>[],
        selectedProject: 0,
        isNewProjectPopup: false,
        currentPage: 1,
    },

    mutations: {
        setClients: (state, records: AClientModel[]) => (state.clients = records),
        setClient: (state, client: AClientModel) => (state.client = client),
        setProjects: (state, records) => (state.projects = records),
        setSelectedProject: (state, id) => (state.selectedProject = id),
        setIsNewProjectPopup: (state, val) => (state.isNewProjectPopup = val),
        setProjectsCurrentPage: (state, val) => (state.currentPage = val),
    },

    getters: {
        getClients: (state): AClientModel[] => state.clients,
        getClient: (state): AClientModel => state.client,
        getProjects: (state): any => state.projects,
        getSelectedProject: (state): number => state.selectedProject,
        getIsNewProjectPopup: (state): boolean => state.isNewProjectPopup,
        getProjectsCurrentPage: (state): number => state.currentPage,
    },

    actions: {
        async loadClient(store, id: number): Promise<AClientModel> {
            return new Promise((resolve, reject) => {
                AClientApi.loadClient(id)
                    .then((response) => {
                        // TODO: co tak vracat pri chybe nieco ine ako 200vku !
                        if (!response.data.record) {
                            throw 'record_empty';
                        }
                        const record = new AClientModel(response.data.record);
                        store.commit('setClient', record);
                        store.commit('setProjects', record.projects);
                        resolve(record);
                    })
                    .catch((err) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        loadClients({ commit, getters }): Promise<AClientModel[]> {
            return new Promise((resolve, reject) => {
                AClientApi.loadClients()
                    .then((response: any) => {
                        const records = [];
                        for (var i in response.data.records) {
                            records.push(new AClientModel(response.data.records[i]));
                        }
                        commit('setClients', records);
                        resolve(records);
                    })
                    .catch((err: any) => {
                        Env.log.error(err);
                        reject(err);
                    });
            });
        },

        async deleteClientProject({ state }, projectId): Promise<any> {
            const { data } = await AClientApi.deleteProject(projectId);
            state.projects = state.projects.filter((i) => i.id != projectId);
            return data;
        },
    },
};

export default store;
